/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { GlobalStyle } from 'styles/global-styles';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { useTranslation } from 'react-i18next';
import { Networth } from './pages/Networth';

import { NetworthProvider } from './Provider/NetworthProvider';

import { Asset2 } from './pages/Asset';

import { Layout } from './components/Layout/Loadable';
import { AssetOverview } from './components/AssetOverview/Loadable';
import { Signup } from './pages/Signup/Loadable';
import { Lifetime } from './pages/Lifetime/Loadable';
import { Planning } from './pages/Planning/Loadable';
import { GoalFor } from './pages/GoalFor/Loadable';
import { GoalPlanner } from './pages/GoalPlanner/Loadable';
import { GoalPlannerProvider } from './Provider/GoalPlannerProvider';
import { UserInfo } from './pages/UserInfo/Loadable';
import { NavbarProvider } from './Provider/NavbarProvider';
import { Overview } from './pages/Overview/Loadable';
import { OverviewProvider } from './Provider/OverviewProvider';
import { GoalDetails } from './pages/GoalDetails/Loadable';
import { ConnectBank } from './components/ConnectBank/Loadable';
import { AuthenticatedRoute } from './components/AuthenticatedRoute/Loadable';
import { Addasset } from './pages/Addasset/Loadable';

import { VerifyOtp } from './pages/VerifyOtp/Loadable';
import { Modal } from './components/Modal/Loadable';
import { Debt } from './pages/Debt/Loadable';
import { AddDebtForm } from './components/AddDebtForm/Loadable';
import { Insights } from './pages/Insights/Loadable';
import { Advisor } from './pages/Advisor/Loadable';
import { AdvisorSignin } from './components/AdvisorSignin/Loadable';

import { Individiual } from './components/SequentialSteps/Loadable';
import { AdvisorProvider } from './Provider/AdvisorProvider';
import { AdvisorDashboard } from './pages/AdvisorDashboard/Loadable';
import { AdvisorGoals } from './components/AdvisorGoals/Loadable';
import { AdvisorMainHome } from './components/AdvisorMainHome/Loadable';
import { AdvisorLayout } from './components/AdvisorLayout/Loadable';
import { ClientProfile } from './pages/ClientProfile/Loadable';
import { AdvisorClientSubscription } from './components/AdvisorClientSubscription/Loadable';
import { AdvisorClientDetailPage } from './components/AdvisoClientDetailPage';
import { ClientList } from './pages/ClientList/Loadable';
import { AuthProvider } from './Provider/AuthProvider';
import { Toaster } from 'react-hot-toast';
import { PortfolioProvider } from './Provider/PortfolioProvider';
import { InviteProvider } from './Provider/inviteProvider';
import { AssetDetails } from './components/AssetDetails/Loadable';
import { Yourplan } from './pages/Yourplan/Loadable';
import { WealthChecker } from './pages/WealthChecker/Loadable';
import { TestProvider } from './Provider/TestProvider';

import { AssetAllocator } from './pages/AssetAllocator';
import { EducationGoal } from './components/EducationGoal';
import { EmergencyGoal } from './components/EmergencyGoal';
import { CarGoal } from './components/CarGoal';
import { Retirement } from './components/RetirementGoal';
import { Wedding } from './components/WeddingPlan';
import { Vacation } from './components/VacationPlan';
import { DownPaymentGoal } from './components/DownPaymentGoal';
import { SavingsGoal } from './components/SavingsGoal';
import { HomeLoan } from './components/HomeLoanGoal';
import { ClientInvite } from './components/ClientInvite/Loadable';
import { ClientQuiz } from './components/ClientQuiz/Loadable';
import { SequentialSteps } from './components/SequentialSteps';
import { CustomerSettings } from './pages/CustomerSettings/Loadable';
import { AdvisorAddAsset } from './pages/AdvisorAddAsset/Loadable';
import { VerifyInvite } from './components/VerifyInvite/Loadable';
import { ChooseProfile } from './pages/ChooseProfile/Loadable';

export function App() {
  const [isHomePage, setIsHomePage] = React.useState(true);
  const { i18n } = useTranslation();
  return (
    <NetworthProvider>
      <Toaster position="top-center" reverseOrder={false} />

      <GoalPlannerProvider>
        <AdvisorProvider>
          <NavbarProvider>
            <OverviewProvider>
              <BrowserRouter>
                <Helmet
                  titleTemplate="%s - Lighthouz"
                  defaultTitle="Lighthouz"
                  htmlAttributes={{ lang: i18n.language }}
                >
                  <meta name="description" content="Financial wellness" />
                </Helmet>
                <AuthProvider>
                  <Routes>
                    <Route
                      path="/wealth-check"
                      element={
                        <TestProvider>
                          <WealthChecker />
                        </TestProvider>
                      }
                    />
                    <Route element={<AuthenticatedRoute component={Layout} />}>
                      <Route path="/networth" element={<Networth />} />
                      <Route path="*" element={<NotFoundPage />} />
                      <Route path="/assets" element={<Asset2 />} />
                      <Route
                        path="/asset-overview"
                        element={<AssetOverview />}
                      />
                      <Route path="/asset-basket" element={<Modal />} />
                      <Route path="/lifetime" element={<Lifetime />} />
                      <Route path="/debt" element={<Debt />} />
                      <Route path="/plans" element={<Yourplan />} />
                      <Route
                        path="/planning/downpayment"
                        element={<DownPaymentGoal />}
                      />
                      <Route
                        path="/planning/savings"
                        element={<SavingsGoal />}
                      />
                      <Route
                        path="/planning/education"
                        element={<EducationGoal />}
                      />
                      <Route
                        path="/planning/emergencyfunds"
                        element={<EmergencyGoal />}
                      />
                      <Route path="/planning/car" element={<CarGoal />} />
                      <Route path="/planning/home" element={<HomeLoan />} />
                      <Route
                        path="/planning/retirement"
                        element={<Retirement />}
                      />
                      <Route path="/planning/wedding" element={<Wedding />} />
                      <Route path="/planning/vacation" element={<Vacation />} />
                      <Route path="/planning" element={<Planning />} />
                      <Route path="/goalfor" element={<GoalFor />} />
                      <Route path="/goalplanner" element={<GoalPlanner />} />
                      <Route path="/insights" element={<Insights />} />

                      <Route path="/addasset" element={<Addasset />} />
                      <Route path="/overview" element={<Overview />} />
                      <Route path="/settings" element={<CustomerSettings />} />
                      <Route
                        path="/assetdetail/:assetName"
                        element={<AssetDetails />}
                      />
                      <Route
                        path="/goalDetails/:goalid"
                        element={<GoalDetails />}
                      />
                      <Route
                        path="/asset-allocator/:goalid"
                        element={<AssetAllocator />}
                      />
                    </Route>
                    {/* <Route
                      path="/client/:invite_id"
                      element={<AcceptInvite />}
                      /> */}

                    <Route element={<AuthenticatedRoute />}>
                      <Route path="/customer/signin/:id" element={<Signup />} />
                      <Route path="/customer/signin" element={<Signup />} />
                      <Route path="/info" element={<UserInfo />} />
                      <Route path="/advisor/signup" element={<Advisor />} />
                      <Route
                        path="/advisor/signin"
                        element={<AdvisorSignin />}
                      />

                      <Route path="/verify" element={<VerifyOtp />} />

                      <Route
                        path="/choose-profile"
                        element={<ChooseProfile />}
                      />
                    </Route>

                    <Route path="/single" element={<Individiual />} />

                    <Route path="/bank" element={<ConnectBank />} />
                    <Route path="/addDebt" element={<AddDebtForm />} />

                    <Route path="/advisor/goals" element={<AdvisorGoals />} />

                    <Route
                      path="/advisor/sequentialsteps"
                      element={
                        <AuthenticatedRoute component={SequentialSteps} />
                      }
                    />

                    <Route
                      element={
                        <AuthenticatedRoute
                          component={routeProps => (
                            <AdvisorLayout
                              {...routeProps}
                              setIsHomePage={setIsHomePage}
                            />
                          )}
                        />
                      }
                    >
                      <Route path="/advisor/clients" element={<ClientList />} />
                      <Route
                        path="/advisor/clients/:id"
                        element={
                          <PortfolioProvider>
                            <AdvisorClientDetailPage />
                          </PortfolioProvider>
                        }
                      />
                      <Route
                        path="/advisor/dashboard"
                        element={<AdvisorDashboard isHomePage={isHomePage} />}
                      />
                      <Route
                        path="/advisor/client-profile"
                        element={<ClientProfile />}
                      />
                      <Route
                        path="/advisor/dashboard"
                        element={<AdvisorMainHome />}
                      />
                      <Route
                        path="/advisor/addasset/:id"
                        element={
                          <PortfolioProvider>
                            <AdvisorAddAsset />
                          </PortfolioProvider>
                        }
                      />
                      <Route
                        path="/advisor/subscription"
                        element={<AdvisorClientSubscription />}
                      />
                    </Route>

                    <Route
                      path="/advisor/client-invite"
                      element={
                        <InviteProvider>
                          <ClientInvite />
                        </InviteProvider>
                      }
                    />
                    <Route path="/client/:uuid" element={<VerifyInvite />} />
                    <Route
                      path="/client/partner/:uuid"
                      element={<VerifyInvite />}
                    />
                  </Routes>
                </AuthProvider>
                <GlobalStyle />
              </BrowserRouter>
            </OverviewProvider>
          </NavbarProvider>
        </AdvisorProvider>
      </GoalPlannerProvider>
    </NetworthProvider>
  );
}
